import {
  BannerCta,
  BannerMessage,
  BannerService,
} from '@services/banner.service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NgClass, AsyncPipe } from '@angular/common';
import { SuiButtonComponent } from '@sui/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-banner-container',
  templateUrl: './banner-container.component.html',
  styleUrl: './banner-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, SuiButtonComponent, AsyncPipe, TranslatePipe],
})
export class BannerContainerComponent {
  banners$: Observable<BannerMessage[]> = this.bannerService.banners$;

  private router = inject(Router);
  constructor(private bannerService: BannerService) {}
  dismiss(id: string) {
    this.bannerService.dismiss(id);
  }

  // Add this method in the component to route/dispatch for CTAs:
  onCta(c: BannerCta) {
    // Handle your app-specific actions here
    // e.g., if (c.action === 'auth:login') this.router.navigate(['/login']);
    // or emit to a central command bus
    console.log('CTA clicked:', c);
    switch (c.action) {
      case 'close':
        this.bannerService.dismissAll();
        break;
      case 'page:refresh':
        window.location.reload();
        break;
      case 'release-notes:open':
        // The release notes browser pinned to the announced version (WAP-1818); the banner stays until the reload.
        void this.router.navigate(
          c.meta?.version
            ? ['/analytics/release-notes', c.meta.version]
            : ['/analytics/release-notes'],
        );
        break;
      case 'auth:login':
        // Navigate to login page or open login modal
        // this.router.navigate(['/login']);
        console.log('Navigate to login');
        break;
      case 'support:open':
        // Open support chat or navigate to support page
        // this.router.navigate(['/support']);
        console.log('Open support');
        break;
      default:
        console.warn('Unknown CTA action:', c.action);
    }
  }
}
